import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory, BrowserHistoryOptions } from 'history';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import releaseConfig from 'releaseConfig';

let appInsightsInstance: ApplicationInsights | null = null;
export const reactPlugin = new ReactPlugin();
export const clickPlugin = new ClickAnalyticsPlugin();
export const getOrSetUpAppInsights = (): ApplicationInsights | null => {
  const connectionString = releaseConfig.connectionString.startsWith('#{')
    ? 'InstrumentationKey=7f7fdb22-0459-4997-8292-171bc346e8da;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/'
    : releaseConfig.connectionString;

  if (appInsightsInstance) {
    return appInsightsInstance;
  }

  if (!connectionString) {
    return null;
  }

  const browserHistory = createBrowserHistory({ basename: '' } as BrowserHistoryOptions);
  appInsightsInstance = new ApplicationInsights({
    config: {
      connectionString,
      autoTrackPageVisitTime: true,
      enableAjaxErrorStatusText: true,
      enableAjaxPerfTracking: true,
      enableCorsCorrelation: true,
      extensions: [reactPlugin, clickPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
        [clickPlugin.identifier]: { autoCapture: true }
      }
    }
  });
  appInsightsInstance.loadAppInsights();
  return appInsightsInstance;
};
